export default {"src":"/_next/static/media/loader-one.a60d8e47.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};